import styled from "@emotion/styled";
import CustomLink from "../custom-link/custom-link.component";
import LogoSVG from "../../assets/branded-logo.svg";
import LogoLinkedin from "../../assets/linkedin.svg";
import LogoLoginSVG from "../../assets/login.svg";
import Typography from "@mui/material/Typography";
import { Link } from "react-scroll";
import { Grid } from "@mui/material";
import { CustomButton } from "../custom-button/custom-button.styles";
import CustomImage from "../custom-image/custom-image.component";
export const Wrapper = styled.footer`
  color: white;
  padding: 1rem 0 1.75rem;
  background-color: ${({
  theme
}) => theme.palette.primary.main};
  border-top: 0.14rem solid rgba(255, 255, 255, 0.23);
  z-index: 1;
  ${({
  theme
}) => theme.breakpoints.up("md")} {
    padding: 3rem 0 1.75rem;
  }
  z-index: 50;
`;
export const BackTop = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
  width: 90px;
  margin: 1.5rem 0 1.5rem auto;

  ${({
  theme
}) => theme.breakpoints.down("sm")} {
    margin: 0.25rem auto 3.5rem;
  }

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    display: none;
  }
  position: relative;

  font-size: ${({
  theme
}) => theme.typography.pxToRem(14)};

  svg {
    position: absolute;
    font-size: 2rem;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
export const LinkHome = styled(CustomLink)`
  display: flex;
  &.logo {
    margin-bottom: 2rem;

    ${({
  theme
}) => theme.breakpoints.up("md")} {
      margin-bottom: 6.5rem;
    }
  }

  &.links {
    color: #fff;
    font-size: 14px;
    text-decoration-line: underline;
  }
`;
export const Button = styled(CustomButton)`
  ${({
  theme
}) => theme.breakpoints.down("md")} {
    padding: 15px 18px;
    font-size: 1rem;
  }
`;
export const ButtonsWrapper = styled.div`
  // display: flex;
  // flex-direction: row;
  // gap: 17px;
  // align-items: center;
  // font-family: ${({
  theme
}) => theme.fonts.secondary};
  // //font-size: 17px;
  // font-weight: 700;
  // span {
  //   opacity: 0.4;
  // }
  //
  // ${({
  theme
}) => theme.breakpoints.up("md")} {
  //   gap: 30px;
  // }
  //
  // ${({
  theme
}) => theme.breakpoints.down("md")} {
  //   justify-content: center;
  // }

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    max-width: 370px;
  }
`;
export const LinkButton = styled(CustomLink)`
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
  box-shadow: inset 0 0 0 1px white;
  border-radius: 100px;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: relative;
  padding: 0.9rem 1.5rem;

  ${({
  borderColor
}) => borderColor ? `box-shadow: inset 0 0 0 1px ${borderColor};` : ""};

  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease-in-out;
  }
  gap: 10px;

  &.withLogo {
    justify-content: flex-start;

    ${({
  theme
}) => theme.breakpoints.up("sm")} {
      justify-content: center;
    }

    ${({
  theme
}) => theme.breakpoints.up("md")} {
      justify-content: flex-start;
    }
  }
`;
export const BookLogoWrapper = styled.div`
  border-radius: 100%;
  background-color: white;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    width: 48px;
    height: 48px;
  }

  position: absolute;
  right: 4px;
`;
export const Text = styled(Typography)`
  font-family: ${({
  theme
}) => theme.fonts.secondary};
  font-size: 1rem;
  font-weight: 700;

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    font-size: 17px;
  }
`;
export const Logo = styled(LogoSVG)`
  width: 224px;
  ${({
  theme
}) => theme.breakpoints.up("lg")} {
    width: 240px;
  }

  ${({
  theme
}) => theme.breakpoints.up(980)} {
    width: 192px;
  }
`;
export const LogoWrapper = styled(Grid)``;
export const LogoLinkSVG = styled(LogoLinkedin)`
  width: 28px;
  height: 28px;
`;
export const LogoLogin = styled(LogoLoginSVG)`
  width: 18px;
  height: 18px;
  position: absolute;
  right: -22px;
  top: 5px;
`;
export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const LinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const Item = styled(CustomLink)`
  align-self: flex-start;
  color: white;
  position: relative;
  text-decoration: underline;

  font-size: 1.125rem;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  &.selected {
    color: ${({
  theme
}) => theme.palette.tertiary.light};
  }
`;
export const Name = styled(Typography)`
  color: #fff;
  font-size: ${({
  theme
}) => theme.typography.pxToRem(18)};
  font-weight: 700;
  line-height: 1.5rem;
  text-transform: capitalize;
`;
export const Links = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  row-gap: 0.75rem;
`;
export const Rights = styled(Typography)`
  color: #fff;
  font-size: ${({
  theme
}) => theme.typography.pxToRem(14)};
  line-height: normal;
  opacity: 0.7;
  text-align: left;

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    font-size: ${({
  theme
}) => theme.typography.pxToRem(18)};
    text-align: right;
  }
`;
export const BottomWrapper = styled.div`
  margin-top: 1.5rem;

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    margin-top: 2rem;
  }
`;
export const FollowItem = styled(Grid)`
  display: flex;

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    display: none;
  }
  ${({
  theme
}) => theme.breakpoints.up("lg")} {
    display: flex;
    justify-content: flex-end;
  }
`;
export const CertifiedInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;

  ${({
  theme
}) => theme.breakpoints.up("lg")} {
    justify-content: flex-start;
  }
`;
export const CertifiedLogo = styled(CustomImage)`
  min-width: 77px;
  height: 100%;

  img {
    object-fit: contain;
  }
`;
export const CertifiedDescription = styled.div`
  p:first-of-type {
    margin-top: 0;
  }

  a {
    color: white;
  }

  ${({
  theme
}) => theme.breakpoints.up("md")} {
    max-width: 400px;
  }

  font-size: ${({
  theme
}) => theme.typography.pxToRem(15)};
`;